import React, { useEffect } from "react"
import { withRouter } from "react-router-dom"
import Helmet from "react-helmet"
import { Status } from "@bitcine/cs-theme"
import { useDispatch, useSelector } from "react-redux"
import { getLoginType } from "@api/auth"
import ExternalLogin from './external_login'
import InternalLogin from './internal_login'

const Login = () => {

  const externalAuthentication = useSelector(state => state.auth.externalAuthentication)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getLoginType())
  }, [])
  
  return (
    <>
      <Helmet title='CineSend | Log In' />
      <Status pending={externalAuthentication.status === "PENDING"}>
        {externalAuthentication.status === "FAILED" && (
          <div
            className='flex items-center rounded p2 mb2'
            style={{ background: '#FEF7EC', border: '1px solid #FBAD46' }}
            data-test-id='login-type-failed-text'>
            <span className='material-icons mr1' style={{ color: '#FBAD46' }}>warning</span>
            <span style={{ fontSize: '13px', color: '#75530A' }}>
              We couldn't confirm your organization's sign-in method. If your organization uses single sign-on, please refresh and try again.
            </span>
          </div>
        )}
        {externalAuthentication.external_authentication_enabled ? <ExternalLogin info={externalAuthentication} /> : <InternalLogin />}
      </Status>
    </>
  )
}


export default withRouter(Login)